import { createVNode, render } from 'vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { isConfirmDialogOpen, openConfirmDialog } from './confirmDialogState'

let hostMounted = false
let hostEl: HTMLDivElement | null = null

/** 在 body 上挂载唯一的 ConfirmDialog 宿主（与 ElMessageBox 一样是全局单例）。 */
function ensureHost() {
  if (hostMounted || typeof document === 'undefined') return
  hostMounted = true
  hostEl = document.createElement('div')
  document.body.appendChild(hostEl)
  const vnode = createVNode(ConfirmDialog)
  render(vnode, hostEl)
}

export function isExclusiveConfirmOpen() {
  return isConfirmDialogOpen()
}

export interface ExclusiveConfirmOptions {
  confirmButtonText?: string
  cancelButtonText?: string
  /** Element Plus 兼容参数；本项目自建弹框统一按 warning 样式展示，保留该项以兼容既有调用。 */
  type?: string
  closeOnClickModal?: boolean
}

/**
 * 全局同时只允许一个确认框。已有确认框时再请求直接视为取消，避免 Delete/Enter 叠出多个对话框。
 * 使用本项目内置的暗色弹框样式（ConfirmDialog.vue）。
 */
export function exclusiveConfirm(
  message: string,
  title: string,
  options?: ExclusiveConfirmOptions,
): Promise<boolean> {
  ensureHost()
  return openConfirmDialog(message, title, {
    confirmButtonText: options?.confirmButtonText,
    cancelButtonText: options?.cancelButtonText,
  })
}
